import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const LoadingModal = ({ 'data-testid': dataTestId = 'loading-modal' }) => {
    return (
        <div data-testid={dataTestId} className='loaderWrapper fixed inset-0 z-[99999] bg-black/30 dark:bg-darkThemeBg flex justify-center items-center'>
            <LoadingSpinner />
        </div>
    );
};

export default LoadingModal;
